import { FC, useContext, useEffect, useState } from 'react'
import { observer } from "mobx-react-lite"
import { Context } from '..'
import useWindowDimensions from '../hooks/useWindowDimensions'
import { useFetch } from '../hooks/useFetch'

import '../styles/App.scss'
import '../styles/XSwitch.scss'
import '../styles/XRadioGroup.scss'
import { GlobalFader, AppRouter, Header, LoyaltyFooter } from '../components/widgets'
import { useLocation, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { declOfNum, getCountryCode, getOS, isNullOrUndefined, isSplashPath } from "../utils"

import { IntlProvider } from 'react-intl'
import { LOCALES } from './i18n/locales'
import { YMaps } from '@pbe/react-yandex-maps'
import { StorageKey } from '../constants'

import { getSettings } from "../api/core"
import Snow from '../components/ui/Snow'
import FloatMessage from '../components/ui/FloatMessage'
import { RouteNames } from './router'
import Modal from '../components/widgets/Modal'
import ProjectReview from '../components/modals/ProjectReview'
import {APP_SETTINGS} from '../constants/settings'

const App: FC = () => {

  const { store, payStore } = useContext(Context)
  const location = useLocation()
  
  const [searchParams, setSearchParams] = useSearchParams()
  
  const [timeToExp, setTimeToExp] = useState("")
  const [userPhone, setUserPhone] = useState("")
  
  const { width, height } = useWindowDimensions()
  
  const [restoreSettings, isRestoreLoading, errorRestore] = useFetch(async () => {
    let dt: any = localStorage.getItem(StorageKey.SETTING_DATE)
    if (dt != null) {
      dt = parseInt(dt)
      const now = moment().unix()
      if ((dt + 86400) < now) {
        fetchSettings()
        return
      }
    } else {
      localStorage.setItem(StorageKey.SETTING_DATE, `${moment().unix()}`);
    }
    
    let tw: any = localStorage.getItem(StorageKey.SETTING_TW)
    let tr: any = localStorage.getItem(StorageKey.SETTING_TR)
    let fr: any = localStorage.getItem(StorageKey.SETTING_FR)

    if (tw != null && tr != null && fr != null) {
      tw = JSON.parse(tw)
      tr = JSON.parse(tr)
      fr = JSON.parse(fr)

      store.setTechworks(tw.data)
      store.setFranchise(fr.data)

      let lst: any = {}, lst2: any[] = [], lst3: any[] = [];
      tr.data.forEach((lang: any) => {
        let ccode = getCountryCode(lang.nameEn)
        lst2.push({ name: lang.name, nameEn: lang.nameEn, code: ccode })

        lst[ccode] = {};
        lang.items.forEach((item) => {
          lst[ccode][item.name] = item.value;
        })

        lst3.push({...lang})
      });

      console.log(lst, lst2);

      const restoreLocale = localStorage.getItem(StorageKey.LOCALE)
      if (restoreLocale != null) {
        store.setLocale(restoreLocale)
      } else {
        store.setLocale(lst2[0].code)
        localStorage.setItem(StorageKey.LOCALE, lst2[0].code)
      }

      store.setTransAll(lst3)
      store.setTranslations(lst)
      store.setLocales(lst2)

      store.setIsSettingsInited(true)
    } else {
      fetchSettings()
    }
  })

  const [fetchSettings, isSetsLoading, errorSets] = useFetch(async () => {
    // const now = moment().unix()
    // const dtx = moment("2026-04-05 00:00:00").unix()

    // console.log(now, dtx)
    // let tm2 = `${((dtx - now) / 60 / 60).toFixed(2)}`
    // let tmx = tm2.split(".")
    // let tm = `${tmx[0]} ${declOfNum(parseInt(tmx[0]), ["час", "часа", "часов"])}, ${tmx[1]} ${declOfNum(parseInt(tmx[1]), ["минута", "минуты", "минут"])}`
    // setTimeToExp(prev => prev = tm)

    // if (now < dtx) {
    //   setInterval(() => {
    //     let nw = moment().unix()
    //     let tm2 = `${((dtx - nw) / 60 / 60).toFixed(2)}`
    //     let tmx = tm2.split(".")
    //     let tm = `${tmx[0]} ${declOfNum(parseInt(tmx[0]), ["час", "часа", "часов"])}, ${tmx[1]} ${declOfNum(parseInt(tmx[1]), ["минута", "минуты", "минут"])}`
    //     setTimeToExp(prev => prev = tm)
    //   }, 1000)
    //   return
    // }

    const res = APP_SETTINGS

    console.log(res)

    try {

      const tw = res.settings.find((v: any) => v.name == "techworks")

      store.setTechworks(tw.data)
      store.setLocales([{name: "Русский", nameEn: "Russian", code: LOCALES.RUSSIAN}])

      localStorage.setItem(StorageKey.SETTING_TW, JSON.stringify(tw))

      if (tw.data.state && location.pathname != "/techworks") {
        window.location.href = "/techworks"
      }
    } catch (e: any) {
      console.log(e)
    }

    store.setIsSettingsInited(true)

    localStorage.setItem(StorageKey.SETTING_DATE, `${moment().unix()}`)
  })

  const fetchReferal = () => {
    const ref = searchParams.get("r")

    console.log(`Referal ID: ${ref}`)

    if (ref != null) {
      localStorage.setItem(StorageKey.REFERAL_ID, `${ref}`)
    }
  }

  useEffect(() => {
    store.setWidth(width)
    if (width <= 768) {
      store.setIsMobile(true)
    } else {
      store.setIsMobile(false)
    }
  }, [width, height])

  useEffect(() => {
    if (width <= 768) {
      store.setIsMobile(true)
    } else {
      store.setIsMobile(false)
    }

    fetchSettings()

    localStorage.removeItem("assyx_toggled")

    fetchReferal()

    const onMouseUp = (event: any) => {
      console.log(event)
      let oldClass = document.body.classList.contains("red")
      const inter = setInterval(() => {
        const selection = window.getSelection()
        console.log(selection)
        if (selection && selection.type != "Range") {
          if (oldClass) {
            document.body.classList.remove("red")
          } else {
            document.body.classList.add("red")
          }
          
          clearInterval(inter)
        }
      }, 1000)
    }

    store.setPlatform(getOS())

    window.addEventListener("mouseup", onMouseUp)

    return () => {
      window.removeEventListener("mouseup", onMouseUp)
    }
  }, [])
  
  // Фейдер с заглушкой на лэндинге и в витрине магазина; на остальных (например /auth) не показываем. 
  const showSplash = isSplashPath(location.pathname)

  if (store.techworks.state) {
    return (
      <>
        {showSplash ? <GlobalFader /> : null}
        <div className="techworks">
          <div className="techworks_wrap">
            <h1>Технические работы</h1>
            <p>На сайте проводятся технические работы<br/><br/>Приблизительная дата завершения работ<br/><b>25 апреля, 12:00</b></p>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {/* Рендерим до ожидания настроек: тогда заглушка может показаться сразу, а не после API. */}
      {showSplash ? <GlobalFader /> : null}
      {store.isSettingsInited ? (
      <YMaps query={{lang: "ru_RU", apikey: "ddba014a-2dcd-4f60-9c58-4bd8d9d0c0e4"}}>
        {location.pathname != "/" && !location.pathname.includes("/store") ? <>
          <Header
            animationToggle={store.animationToggle}
            onOpenMenu={() => {}}
            goToSection={() => {}} />
        </> : <></>}
        
        <AppRouter />
        <Snow />
        <FloatMessage />

        <Modal
          visible={payStore.isPaymentVisible}
          title=""
          content={<>
            <div id="payment-formx"></div>
          </>}
          onClose={() => payStore.setIsPaymentVisible(false)}
          />

        {location.pathname != RouteNames.LOYALTY_S_BLOCKED ? <>
          <LoyaltyFooter />
          <ProjectReview />
        </> : <></>}
      </YMaps>
      ) : null}
    </>
  )
}

export default observer(App)
